export function useNumberFormatter(
    amount: number | string,
    minimumFractionDigits: number = 2,
    maximumFractionDigits: number = 2,
    absolute: boolean = false,
): string {
    const formatter = new Intl.NumberFormat("de-DE", {
        // Changed locale to 'de-DE' for European formatting
        minimumFractionDigits: minimumFractionDigits, // Ensure two decimal places
        maximumFractionDigits: maximumFractionDigits,
    });

    if (typeof amount === "string") {
        amount = parseFloat(amount);
    }

    if (absolute) {
        amount = Math.abs(amount);
    }

    return formatter.format(amount);
}

export function useKwhFormatter(
    amount: number | string,
    minimumFractionDigits: number = 2,
    maximumFractionDigits: number = 2,
    absolute: boolean = false,
): string {
    return (
        useNumberFormatter(
            amount,
            minimumFractionDigits,
            maximumFractionDigits,
            absolute,
        ) + " kWh"
    );
}

export function useKwFormatter(
    amount: number | string,
    minimumFractionDigits: number = 2,
    maximumFractionDigits: number = 2,
    absolute: boolean = false,
): string {
    return (
        useNumberFormatter(
            amount,
            minimumFractionDigits,
            maximumFractionDigits,
            absolute,
        ) + " kW"
    );
}

export function useMoneyFormatter(
    amount: number | string,
    minimumFractionDigits: number = 2,
    maximumFractionDigits: number = 2,
    currency: string = "EUR",
): string {
    const formatter = new Intl.NumberFormat("en-US", {
        // Changed locale to 'en-US' for US formatting (as per design)
        minimumFractionDigits: minimumFractionDigits, // Ensure two decimal places
        maximumFractionDigits: maximumFractionDigits,
        style: "currency",
        currency: currency,
    });

    if (typeof amount === "string") {
        amount = parseFloat(amount);
    }

    return formatter.format(amount).replace(/\./g, ",");
}
